var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-eh",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eh-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-158.7 0H524v512h-682.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#eh-a)",
    transform: "translate(148.8) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-158.3 0h680.9v255.3h-680.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "M-158.3 255.3h680.9v255.3h-680.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-158.3 148.9h680.9v212.8h-680.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "m-158.3 0 340.4 255.3-340.4 255.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.3,
    cy: 255.3,
    r: 68.1,
    fill: "#c4111b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.9,
    cy: 255.3,
    r: 68.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "m334 296.5 29.1-20.7 28.8 21-10.8-34 29-20.9-35.7-.2-11-34-11.2 33.9-35.7-.2 28.7 21.2-11.1 34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/eh.a9221b7322cbbeeba19907184fe408cf.svg";
export { ForwardRef as ReactComponent };